import { AppURLs } from "~/appUrls";
import { makeLazyRoute } from "~/router/makeLazyRoute";
import { withOutlet } from "~/router/withOutlet";

export const monitorRoutes = (url: AppURLs) => [
  {
    lazy: () =>
      import(
        "../components/SentinelDeploymentProvider/SentinelDeploymentProvider"
      ).then((m) => ({
        Component: withOutlet(m.SentinelDeploymentProvider),
      })),
    children: [
      {
        path: url.projectMonitorIndexRoute(":projectId").toString(),
        lazy: makeLazyRoute(() =>
          import("./MonitorOverviewPage/MonitorOverviewPage").then(
            (m) => m.MonitorOverviewPage
          )
        ),
      },
      {
        path: url
          .projectMonitorIssuesIndexRoute(":projectId", ":status")
          .toString(),
        lazy: makeLazyRoute(() =>
          import("./MonitorIssuesIndexPage/MonitorIssuesIndexPage").then(
            (m) => m.MonitorIssuesIndexPage
          )
        ),
      },

      {
        path: url.projectMonitorSystemPerformanceRoute(":projectId").toString(),
        lazy: makeLazyRoute(() =>
          import(
            "./MonitorSystemPerformancePage/MonitorSystemPerformancePage"
          ).then((m) => m.MonitorSystemPerformancePage)
        ),
      },

      {
        path: url.projectMonitorMeteoRoute(":projectId").toString(),
        lazy: makeLazyRoute(() =>
          import("./MonitorMeteoPage/MonitorMeteoPage").then(
            (m) => m.MonitorMeteoPage
          )
        ),
      },
      {
        path: url.projectMonitorModelPerformanceRoute(":projectId").toString(),
        lazy: makeLazyRoute(() =>
          import(
            "./MonitorModelPerformancePage/MonitorModelPerformancePage"
          ).then((m) => m.MonitorModelPerformancePage)
        ),
      },
      {
        path: url.projectMonitorSystemLossesRoute(":projectId").toString(),
        lazy: makeLazyRoute(() =>
          import("./MonitorSystemLossPage/MonitorSystemLossesPage").then(
            (m) => m.MonitorSystemLoss
          )
        ),
      },
      {
        path: url.projectMonitorBlockRoute(":projectId", ":blockId").toString(),
        lazy: makeLazyRoute(() =>
          import("./MonitorBlockRedirect").then((m) => m.MonitorBlockRedirect)
        ),
      },
      {
        path: url
          .projectMonitorBlockRoute(":projectId", ":blockId", "inverter")
          .toString(),
        lazy: makeLazyRoute(() =>
          import("./MonitorBlockInverterPage/MonitorBlockInverterPage").then(
            (m) => m.MonitorBlockInverterPage
          )
        ),
      },
      // {
      //   path: url.projectMonitorSystemPerformanceRoute(":projectId").toString(),
      //   lazy: makeLazyRoute(() =>
      //     import(
      //       "./MonitorSystemPerformancePageBak/MonitorSystemPerformancePage"
      //     ).then((m) => m.MonitorSystemPerformancePage)
      //   ),
      // },
      {
        path: url
          .projectMonitorTimeSeriesAnalysisRoute(":projectId")
          .toString(),
        lazy: makeLazyRoute(() =>
          import(
            "./MonitorTimeSeriesAnalysisPage/MonitorTimeSeriesAnalysisPage"
          ).then((m) => m.MonitorTimeSeriesAnalysisPage)
        ),
      },
    ],
  },
];
